import React, {Component} from "react";
import { Typography, Button, Box } from "@mui/material";

interface Props {
  account: any;
  onConfirm: () => void;
}

export default class ReviewPage extends Component<Props> {
  render() {
    const { account, onConfirm } = this.props;

    if (!account) return null;

    return (
      <>
        <Typography variant="h6">Review Transaction</Typography>

        <Box sx={{ mt: 2 }}>
          <Typography>Account: {account.accountNumber}</Typography>
          <Typography>Name: {account.accountName}</Typography>
          <Typography>
            Balance: {account.currency} {account.balance}
          </Typography>
        </Box>

        <Button
          variant="contained"
          sx={{ mt: 3 }}
          onClick={onConfirm}
        >
          Submit Transaction
        </Button>
      </>
    );
  }
}